import React from 'react';
import './blog4EggFreezing.css';

const EggFreezingBlog = () => {
  return (
    <div className="eggfreezing-blog-container">
      <h1> Egg Freezing, Fertility Preservation, and You</h1>
      <p className="eggfreezing-subheading">A Modern Woman’s Guide to Reproductive Freedom – from Sukam Speciality Clinic</p>

      <section>
        <h2>🌸 Introduction: Why Fertility Preservation Matters</h2>
        <p>
          Modern women are embracing freedom — in career, relationships, and self-growth.
          But one area biology hasn’t caught up with is fertility.
          With egg quality declining after age 35, many women face a dilemma: career or family?
          At Sukam Speciality Clinic, we believe you shouldn’t have to choose.
          Egg freezing empowers you to preserve the possibility of motherhood — on your timeline.
        </p>
      </section>

      <section>
        <h2>⏳ The Biological Clock: What You Need to Know</h2>
        <p>Women are born with a limited number of eggs. Here's the typical decline:</p>
        <ul>
          <li>👶 Birth: 1–2 million eggs</li>
          <li>👧 Puberty: ~300,000 eggs</li>
          <li>👩 Age 30: ~100,000</li>
          <li>👩‍🦳 Age 40: Less than 10,000 (more chromosomal risks)</li>
        </ul>
        <p>
          Natural fertility drops after 30, and fertility treatments also become less effective later.
        </p>
      </section>

      <section>
        <h2>👩‍⚕️ Who Should Consider Egg Freezing?</h2>
        <ul>
          <li>💼 Career-driven women in their late 20s or 30s</li>
          <li>💞 Women without the right partner yet</li>
          <li>👩‍⚕️ Cancer patients before chemotherapy</li>
          <li>👨‍👩‍👧‍👧 Family history of early menopause</li>
          <li>🏳️‍⚧️ LGBTQ+ individuals planning future parenthood</li>
        </ul>
      </section>

      <section>
        <h2>🔬 How Does Egg Freezing Work?</h2>
        <ol>
          <li><strong>Initial Evaluation:</strong> Hormonal tests (AMH, FSH), ultrasound, fertility counseling</li>
          <li><strong>Ovarian Stimulation:</strong> 10–12 days of hormonal injections and monitoring</li>
          <li><strong>Egg Retrieval:</strong> Short procedure under sedation</li>
          <li><strong>Cryopreservation:</strong> Eggs are vitrified at −196°C</li>
          <li><strong>Future Use:</strong> Eggs are thawed, fertilized, and embryos transferred when you’re ready</li>
        </ol>
      </section>

      <section>
        <h2>⚠️ Does It Affect Fertility?</h2>
        <p>No. Egg retrieval doesn’t deplete your egg reserve. It collects eggs your body was going to discard anyway.</p>
      </section>

      <section>
        <h2>📈 Success Rates Based on Age</h2>
        <table>
          <thead>
            <tr><th>Age at Freezing</th><th>Estimated Live Birth Rate (from 10 eggs)</th></tr>
          </thead>
          <tbody>
            <tr><td>30 years</td><td>~60–70%</td></tr>
            <tr><td>35 years</td><td>~50–60%</td></tr>
            <tr><td>38 years</td><td>~30–40%</td></tr>
            <tr><td>40+ years</td><td>&lt;20%</td></tr>
          </tbody>
        </table>
        <p><em>Younger eggs = better success. That’s why we recommend freezing before 35.</em></p>
      </section>

      <section>
        <h2>💰 Cost & Inclusions</h2>
        <ul>
          <li>✅ Hormone tests and fertility scan</li>
          <li>✅ Stimulation injections and ultrasound monitoring</li>
          <li>✅ Egg retrieval with sedation</li>
          <li>✅ Cryopreservation and storage (1–5 years)</li>
        </ul>
        
      </section>

      <section>
        <h2>🌟 Why Choose Sukam?</h2>
        <ul>
          <li>👩‍⚕️ Experienced Fertility Specialist</li>
          <li>🧪 Cutting-edge freezing technology (vitrification)</li>
          <li>🧘‍♀️ Supportive, judgment-free counseling</li>
          <li>🔒 Confidential and secure environment</li>
        </ul>
        <p>We’re here to protect not just your eggs, but your dreams.</p>
      </section>

      <section>
        <h2>🗣️ Real Women, Real Stories</h2>
        <p><strong>Shruthi, 33 (Engineer):</strong> “I wasn’t sure about kids yet, but I didn’t want that decision made for me by time. Now I feel relieved.”</p>
        <p><strong>Susheela, 29 (Breast cancer survivor):</strong> “Freezing my eggs before chemo gave me hope — Sukam made the process smooth and reassuring.”</p>
      </section>

      <section>
        <h2>❤️ Final Thoughts</h2>
        <p>
          Egg freezing isn’t about delaying family. It’s about preserving choice.
          If you’re unsure about your timeline, take the first step with knowledge and guidance.
        </p>
        <div className="cta-box">
          💡 <strong>Book a consultation at Sukam Speciality Clinic today</strong> — and explore your future with freedom, science, and support.
        </div>
      </section>
    </div>
  );
};

export default EggFreezingBlog;
